import React, {useEffect, Suspense} from 'react';
import './MaintenancePage.css';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import maintenance from '../../assets/icons/maintenance.svg';
import closeIcon from '../../assets/icons/close-grey.svg';

import FordCreditLogo from '../../assets/icons/ford-credit-logo.png';
import AppModalDialog from '../../components/AppModalDialog/AppModalDialog';
import Button from '../../components/Button/Button';
import {FormHeaderSection} from '../PrequalSinglePageApp/FormHeaderSection/FormHeaderSection';

function MaintenancePage({maintenanceEndTime, openWindow, appConfig, customerData}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let backUpAgainMessage = 'We will be back up and running shortly.';
  const checkBackMessage = `Please check back!`;
  if (maintenanceEndTime) {
    backUpAgainMessage = `We will be back up and running by ${maintenanceEndTime} EST.`;
  }

  useEffect(() => {
    window.addEventListener('popstate', () => {
      navigate('/');
    });
  }, []);

  const exploreVehicleHandler = () => {
    openWindow(appConfig.exploreVehiclesTarget);
  };

  const getContent = () => (
    <div id='prequal--web--form-section' className='prequal--wc--form-section' data-testid='prequal--web--form-section'>
      {customerData.isDealerHostApplication?.value && (
        <FormHeaderSection
          isDealerHostApplication={customerData.isDealerHostApplication.value}
          dispatch={dispatch}
          customerData={customerData}
          navigate={navigate}
          headerText='Maintenance'
        />
      )}
      <div
        className='prequal--web--maintenance-page-container-fomo'
        data-testid='maintenance-page-container'
        {...(appConfig.maintenanceModal && {style: {paddingTop: '30px'}})}
      >
        {appConfig.maintenanceModal && (
          <div className='prequal--web--maintenance-page-header-container'>
            <img src={FordCreditLogo} alt='Ford Credit Logo' className='prequal--web--maintenance-page-fordlogo' />
            <button className='prequal--web--maintenance-page-closebtn' onClick={() => {}} type='button'>
              <img src={closeIcon} alt='close' className='prequal--web--maintenance-page-closeimg' />
            </button>
          </div>
        )}
        <div>
          <img src={maintenance} alt='Under Maintenance' />
        </div>
        <div className='prequal--web--maintenance-title-fomo'>We&apos;re Sorry</div>

        <div className='prequal--web--maintenance-body-fomo' data-testid='maintenance-body-fomo'>
          This page is down for maintenance. {backUpAgainMessage} {checkBackMessage}
        </div>
        <div className='prequal--web--return-button-section-fomo'>
          <Button
            label='Explore Vehicles Online'
            dataTestId='exploreVehiclesButtonFomo'
            buttonStyle='primary'
            className='prequal--web--return-explore-btn'
            onClick={exploreVehicleHandler}
          />
          {appConfig.maintenanceModal && (
            <Button label='Close' dataTestId='exploreVehiclesButtonFomo' className='prequal--web--return-close-btn' onClick={() => {}} />
          )}
        </div>
      </div>
    </div>
  );

  return (
    <Suspense fallback={<div>Loading...</div>}>
      {appConfig.maintenanceModal ? <AppModalDialog content={getContent} customerData={customerData} isMaintanence /> : <>{getContent()}</>}
    </Suspense>
  );
}

export default MaintenancePage;
